import { render, staticRenderFns } from "./TextInputOptionField.vue?vue&type=template&id=b687d738&lang=pug"
import script from "./TextInputOptionField.vue?vue&type=script&lang=js"
export * from "./TextInputOptionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports